import { Component, OnInit } from '@angular/core';

// block ui template
@Component({
    template: require('./block-ui-template.component.html'),
    styles: [require('./block-ui-template.component.scss')]
})

export class BlockUiTemplateComponent  {
        
}